import { render, staticRenderFns } from "./VLoader.vue?vue&type=template&id=b0cd0046&"
import script from "./VLoader.vue?vue&type=script&lang=ts&"
export * from "./VLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports